import React from "react";
import Grid from "@mui/material/Grid";
import WelcomeHome from "../../components/common/welcomeHome";

export const AdminHome = () => {
  return (
    <div>
      <div className="container__page">
        <Grid
          container
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          paddingBottom="2rem !important"
          padding={{
            xs: "1.5rem",
            sm: "2.25rem 3rem",
            md: "2.25rem 3rem",
            lg: "4.5rem",
            xl: "4.5rem",
          }}
        >
          <WelcomeHome />
        </Grid>
      </div>
    </div>
  );
};
